import { MarketBlogCategoryPage } from '../../../../components/market/MarketBlogsPage'
import { getMarketBlogCategoryProps } from '../../../../lib/market-pages'
import copy from '../../../../data/markets/ae/blogs'

// Blog category page - slug and label in blogCategories (utils/markets.js).
export const getStaticProps = () => getMarketBlogCategoryProps('ae', 'aircon')

export default function Page(props) {
    return <MarketBlogCategoryPage {...props} copy={copy} />
}
